import { render, staticRenderFns } from "./electricityPrice.vue?vue&type=template&id=122af2d1&scoped=true"
import script from "./electricityPrice.vue?vue&type=script&lang=js"
export * from "./electricityPrice.vue?vue&type=script&lang=js"
import style0 from "./electricityPrice.vue?vue&type=style&index=0&id=122af2d1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122af2d1",
  null
  
)

export default component.exports